import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from "@angular/http";
import {CourseM} from "../model/course.model";
import 'rxjs/add/operator/map';
import {CartM} from "../model/cart.model";
import {Util} from "../util/util";

@Injectable()
export class CartService {


  private course: CourseM = new CourseM();

  headers = new Headers();
  options: RequestOptions;

  constructor(private http: Http) {
    this.headers.append('Content-Type', 'application/json');
    this.headers = Util.setHeaderToken(this.headers)
    this.options = new RequestOptions({headers: this.headers});
  }

  reloadToken() {
    this.headers = Util.setHeaderToken(this.headers)
    this.options = new RequestOptions({headers: this.headers});
  }


  getCartList() {
    ////console.log('getCartList');
    this.reloadToken()
    return this.http.get(`/api/cart/getList`, this.options).map(res => res.json());
  }

  addCart(cartM: CartM) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let options = new RequestOptions({headers: headers});

    ////console.log(`course_no:${course.no}`);

    this.reloadToken()
    return this.http.post(`/api/cart/add`, cartM, options);
  }

  deleteCart(course: CourseM) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let options = new RequestOptions({headers: headers});

    ////console.log(`course_no:${course.no}`);

    this.reloadToken()
    return this.http.delete(`/api/cart/delete/${course.no}`, options);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/cart.service.ts